import { FC } from 'react';

import { AccountSettings } from '@shared/components/AccountSettings';

import { useSellerTopNavHook } from '../hooks/useSellerTopNavHook';

const SellerSettingsPage: FC = function SellerSettingsPage() {
  useSellerTopNavHook('계정정보');
  return <AccountSettings />;
};

export default SellerSettingsPage;
